import { render } from "./AddTextBox.vue?vue&type=template&id=4f8c8804"
import script from "./AddTextBox.vue?vue&type=script&lang=js"
export * from "./AddTextBox.vue?vue&type=script&lang=js"

import "./AddTextBox.vue?vue&type=style&index=0&id=4f8c8804&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__